import { MsHydration as u } from "./index529.js";
import { useGlobalStore as d, componentUtils as o, getCmsProperty as f, allContentByLabel as p, extractLink as h, contentByLabel as k } from "@sunrise/shared";
import { defineComponent as C, computed as i } from "vue";
import L from "./index220.js";
const I = C({
  name: "M_Link_List",
  components: {
    MsHydration: u,
    HydratedLinkList: L
  },
  props: {
    cmsContent: { type: Object, required: !0 }
  },
  setup(t) {
    const e = d().requestContext, l = o.isInVisualIdentityModule(), m = f("meinestadt/types#hasMaxColumns", t.cmsContent, !1), r = i(() => p(t.cmsContent, "E_Link").map((s) => {
      const n = h(s);
      if (!(!n || !n.href || new URL(n.href).pathname === (e == null ? void 0 : e.url.pathname)))
        return {
          url: n.href,
          label: o.renderContentTag(n.children)
        };
    }).filter((s) => !!s)), c = i(() => {
      const a = k(t.cmsContent, "Headline");
      return o.renderCMSText(a);
    });
    return {
      hasLinks: i(() => r.value && r.value.length),
      links: r,
      headline: c,
      isInVIM: l,
      hasMaxColumns: m
    };
  }
});
export {
  I as default
};
